import React from 'react';
import './styles.css';

const Header = () =>  <header id="main-header"><h2 id="title-header">Safetec - Extrato Financeiro</h2></header> ;

export default Header;